import { defineComponent as h, provide as P, renderSlot as b, watch as M, nextTick as g, onUnmounted as B, ref as c, computed as p, inject as A, openBlock as E, createElementBlock as F, mergeProps as L, unref as v, onMounted as N, watchEffect as $, toValue as T } from "vue";
import { NumberFlowLite as r, formatToData as k, renderInnerHTML as C, define as S, canAnimate as G, prefersReducedMotion as f } from "number-flow";
import { NumberFlowLite as x } from "number-flow";
import { BROWSER as H } from "esm-env";
const w = Symbol(), j = /* @__PURE__ */ h({
  __name: "NumberFlowGroup",
  setup(a) {
    const s = /* @__PURE__ */ new Set();
    let i = !1;
    return P(w, (t, l) => {
      s.add(t), M(
        l,
        async () => {
          i || (i = !0, s.forEach(async (e) => {
            var u;
            !e.value || !e.value.created || (e.value.willUpdate(), await g(), (u = e.value) == null || u.didUpdate());
          }), await g(), i = !1);
        }
        // { flush: 'pre' } // default
      ), B(() => {
        s.delete(t);
      });
    }), (t, l) => b(t.$slots, "default");
  }
}), R = ["aria-label", "manual", "trend", "continuous", "animated", "transformTiming", "spinTiming", "opacityTiming", "respectMotionPreference", "data-will-change", "digits", "innerHTML", "data"], D = /* @__PURE__ */ h({
  inheritAttrs: !1,
  __name: "index",
  props: {
    transformTiming: { default: () => r.defaultProps.transformTiming },
    spinTiming: { default: () => r.defaultProps.spinTiming },
    opacityTiming: { default: () => r.defaultProps.opacityTiming },
    animated: { type: Boolean, default: () => r.defaultProps.animated },
    respectMotionPreference: { type: Boolean, default: () => r.defaultProps.respectMotionPreference },
    trend: { type: [Number, Function], default: () => r.defaultProps.trend },
    continuous: { type: Boolean, default: () => r.defaultProps.continuous },
    digits: { default: () => r.defaultProps.digits },
    locales: {},
    format: {},
    value: {},
    prefix: {},
    suffix: {},
    willChange: { type: Boolean, default: !1 }
  },
  emits: ["animationsstart", "animationsfinish"],
  setup(a, { expose: s, emit: i }) {
    const o = c();
    s({ el: o });
    const t = i, l = p(() => new Intl.NumberFormat(a.locales, a.format)), e = p(() => k(a.value, l.value, a.prefix, a.suffix)), u = H ? void 0 : C(e.value), m = A(w, void 0);
    return m == null || m(o, e), (n, d) => (E(), F("number-flow-vue", L({
      ref_key: "el",
      ref: o,
      "aria-label": e.value.valueAsString
    }, n.$attrs, {
      role: "img",
      manual: !!v(m),
      trend: n.trend,
      continuous: n.continuous,
      animated: n.animated,
      transformTiming: n.transformTiming,
      spinTiming: n.spinTiming,
      opacityTiming: n.opacityTiming,
      respectMotionPreference: n.respectMotionPreference,
      "data-will-change": n.willChange ? "" : void 0,
      digits: n.digits,
      innerHTML: v(u),
      "data-allow-mismatch": "",
      onAnimationsstart: d[0] || (d[0] = (y) => t("animationsstart")),
      onAnimationsfinish: d[1] || (d[1] = (y) => t("animationsfinish")),
      data: e.value
    }), null, 16, R));
  }
});
S("number-flow-vue", r);
function O({
  respectMotionPreference: a = !0
} = {}) {
  const s = c(!1), i = c(!1);
  return N(() => {
    var o;
    s.value = G, i.value = ((o = f) == null ? void 0 : o.matches) ?? !1;
  }), $((o) => {
    var l;
    if (!T(a)) return;
    const t = ({ matches: e }) => {
      i.value = e;
    };
    (l = f) == null || l.addEventListener("change", t), o(() => {
      var e;
      (e = f) == null || e.removeEventListener("change", t);
    });
  }), p(
    () => s.value && (!T(a) || !i.value)
  );
}
export {
  x as NumberFlowElement,
  j as NumberFlowGroup,
  D as default,
  O as useCanAnimate
};
